import { create } from 'zustand';
import type { ReactNode } from 'react';

export interface ModalState {
  isModalOpen: boolean;
  modalState: ModalStateUnion | undefined;
  openModal: (
    modalState: ModalStateUnion,
    additionalContent?: ReactNode,
    additionalProps?: Record<string, unknown>,
  ) => void;
  closeModal: () => void;
  resetModalStore: () => void;
  additionalContent: ReactNode;
  additionalProps: Record<string, unknown>;
}

export const MODAL_STATE = {
  EXAMPLE_MODAL: 'EXAMPLE_MODAL',
  LOAN_AGREEMENTS: 'LOAN_AGREEMENTS',
  LOAN_RECIPIENT_DETAILS: 'LOAN_RECIPIENT_DETAILS',
  LOAN_ACTION_CARD_MODAL: 'LOAN_ACTION_CARD_MODAL',
  LOAN_CANCEL: 'LOAN_CANCEL',
  REPRESENTATIVE_ADDRESS_DATA: 'REPRESENTATIVE_ADDRESS_DATA',
  LIBERIS_AGREEMENTS_ADDITIONAL_INFO: 'LIBERIS_AGREEMENTS_ADDITIONAL_INFO',
  LIBERIS_MULTIPROVIDER_LOAN_STAGE: 'LIBERIS_MULTIPROVIDER_LOAN_STAGE',
  NO_AVAILABLE_OFFERS: 'NO_AVAILABLE_OFFERS',
  PRAGMA_FORM: 'PRAGMA_FORM',
  PROMOTION_CODE_ERROR: 'PROMOTION_CODE_ERROR',
} as const;

export type ModalStateUnion = (typeof MODAL_STATE)[keyof typeof MODAL_STATE];

export type ModalStateKeys = keyof typeof MODAL_STATE;

const initialModalStoreData = {
  isModalOpen: false,
  modalState: undefined,
  additionalContent: undefined,
  additionalProps: {},
};

export const useModalStore = create<ModalState>((set) => ({
  ...initialModalStoreData,
  openModal: (modalState, additionalContent, additionalProps = {}) => {
    set(() => ({
      isModalOpen: true,
      modalState,
      additionalContent,
      additionalProps,
    }));
  },
  closeModal: () => {
    set(() => ({
      isModalOpen: false,
      modalState: undefined,
      additionalProps: {},
    }));
  },
  resetModalStore: () => {
    set(() => initialModalStoreData);
  },
}));
